module.exports = __webpack_public_path__ + "static/assets/3ccfc32dfc352d8a3cd4e3e5e2e802c2.svg";